import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import TransferOrder from '../entities/transfer-orders/transfer-order'
import TransferOrderLine from '../entities/transfer-orders/transfer-order-line'

import TransferOrderItem from '../entities/transfer-orders/search-transfer-order-item'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface TransferOrderState extends ListState<TransferOrderItem> {
    viewTransferOrder: TransferOrder
}
class TransferOrderModule extends ListModule<TransferOrderState, any, TransferOrderItem>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<TransferOrderItem>(),
        loading: false,
        viewTransferOrder: new TransferOrder(),
        listLine: new Array<TransferOrderLine>(),

    }
    actions = {
        async getAll(context: ActionContext<TransferOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/TransferOrderRequest/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<TransferOrderItem>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<TransferOrderState, any>, payload: any) {
            await Ajax.post('/api/services/app/TransferOrderRequest/Create', payload.data);
        },
        async get(context: ActionContext<TransferOrderState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/TransferOrderRequest/GetDetail?Id=' + payload.data.id);
            return reponse.data.result as TransferOrder;
        },
        async cancel(context: ActionContext<TransferOrderState, any>, payload: any) {
            await Ajax.post('/api/services/app/TransferOrderRequest/Cancel/', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: TransferOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: TransferOrderState, pagesize: number) {
            state.pageSize = pagesize;
        },
        view(state: TransferOrderState, TransferOrder:TransferOrder) {
            state.viewTransferOrder = TransferOrder;
        }
        
    }
}
const transferOrderModule = new TransferOrderModule();
export default transferOrderModule;